'use strict';

/**
 * @description Dashboard Component
 * @returns {Object} Devuelve la instancia del componente
 */

import { store } from '../../app.init.js';
import i18n from 'i18next';
import { servicesPoliticaPrivacidad } from './politicaprivacidad.services.js';
import { templatePoliticaPrivacidad } from './politicaprivacidad.template.js';
import { componentRapidAccess } from '../../shared/components/rapid-access/rapid-access.component.js';

let componentPoliticaPrivacidad = (function () {
  let context = {};
  let handlers = {};
  let renderSuccess = false;

  let preRenderComponent = () => {
    // Asi accedemos a la propiedad del store
    const state = store.getState();
    document.title = `${i18n.t('legal_advise')} | ${i18n.t('page_subtitle')}`;
    context.name = state.exampleReducer.name;
  };

  let renderComponent = async () => {
    const state = store.getState();

    try {
      // Render the template to the document
      let contactData = await servicesPoliticaPrivacidad.init(
        state.exampleReducer.currentLang
      );

      templatePoliticaPrivacidad(contactData);
      changetab(contactData);

      const RapidAccessData = [
        {
          id: '#informacion-general',
          title: 'Información general',
        },
        {
          id: '#condiciones-generales',
          title: 'Condiciones generales',
        },
      ];
      componentRapidAccess.render(RapidAccessData);

      renderSuccess = true;
    } catch (error) {
      renderSuccess = false;
    }
    document
      .querySelector('.esios-layout__wrap')
      .classList.add('esios-layout__wrap--pp');
    document
      .querySelector('.esios-layout__footer-image')
      .classList.add('esios-layout__footer-image--pp');
  };

  const changetab = () => {
    document.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var href = this.getAttribute('href');
        var elem =
          document.querySelector(href) ||
          document.querySelector(
            'a[name=' + href.substring(1, href.length) + ']'
          );
        window.scroll({
          top: elem.offsetTop + 250,
          left: 0,
          behavior: 'smooth',
        });
      });
    });
  };

  let postRenderComponent = () => {
    const state = store.getState();
    context.name = state.exampleReducer.name;
  };

  let init = () => {
    //Call pre render component
    preRenderComponent();

    // Call render component
    renderComponent();

    // Call post render component if it has been rendered
    renderSuccess ? postRenderComponent() : '';
  };

  return {
    render: init,
  };
})();

export { componentPoliticaPrivacidad };
